"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sodium = require("libsodium-wrappers-sumo");
var ArrayUtil_1 = require("../util/ArrayUtil");
var MemoryUtil_1 = require("../util/MemoryUtil");
var KeyDerivationUtil = {
    hkdf: function (salt, input, info, length) {
        var convert_type = function (value) {
            if (typeof value === 'string') {
                return sodium.from_string(value);
            }
            return value;
        };
        salt = convert_type(salt);
        input = convert_type(input);
        info = convert_type(info);
        var HASH_LEN = 32;
        var salt_to_key = function (received_salt) {
            var keybytes = sodium.crypto_auth_hmacsha256_KEYBYTES;
            if (received_salt.length > keybytes) {
                return sodium.crypto_hash_sha256(received_salt);
            }
            var key = new Uint8Array(keybytes);
            key.set(received_salt);
            return key;
        };
        var extract = function (received_salt, received_input) {
            return sodium.crypto_auth_hmacsha256(received_input, salt_to_key(received_salt));
        };
        var expand = function (tag, received_info, received_length) {
            var num_blocks = Math.ceil(received_length / HASH_LEN);
            var hmac = new Uint8Array(0);
            var result = new Uint8Array(0);
            for (var index = 0; index <= num_blocks - 1; index++) {
                var buf = ArrayUtil_1.default.concatenate_array_buffers([hmac, received_info, new Uint8Array([index + 1])]);
                hmac = sodium.crypto_auth_hmacsha256(buf, tag);
                result = ArrayUtil_1.default.concatenate_array_buffers([result, hmac]);
            }
            return new Uint8Array(result.buffer.slice(0, received_length));
        };
        var key = extract(salt, input);
        MemoryUtil_1.default.zeroize(input);
        MemoryUtil_1.default.zeroize(salt);
        return expand(key, info, length);
    },
};
exports.default = KeyDerivationUtil;
//# sourceMappingURL=KeyDerivationUtil.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/util/KeyDerivationUtil.js
// module id = 110
// module chunks = 0 1